import { ApplicationSanitized } from '@backend/sanitize/application'

/**
 * Gets the fee amount to display to the user.
 * For submitted applications, returns payableFee (actual amount after waivers).
 * For draft applications, returns amount (program fee, already evaluated by policy).
 */
export function getApplicationFeeAmount(application: ApplicationSanitized | null): number {
  return (
    application?.attributes?.applicationFee?.payableFee ??
    application?.attributes?.applicationFee?.amount ??
    0
  )
}

/**
 * Function that programmatically determines if the application has a fee.
 */
export function hasApplicationFee(application: ApplicationSanitized | null): boolean {
  return getApplicationFeeAmount(application) > 0
}
